import { API } from "@/services"

export const ERROR_CAPTURE_ENDPOINTS = {
  sync(data={}){
    return API.Axios.error_capture.v1.request({
      url: `error-capture/sync`,
      method: 'POST',
      data,
    })
  },
  get(params={},extra){
    return API.Axios.error_capture.v1.request({
      ...extra,
      url: `error-capture`,
      method: 'GET',
      params,
    })
  },
  downloadExcel(params={}){
    return API.Axios.error_capture.v1.request({
      url: `error-capture/excel/download`,
      method: 'GET',
      params,
      responseType: 'blob'
    })
  },
  getByCpDomainList(cp_domain='',params={}){
    return API.Axios.error_capture.v1.request({
      url: `error-capture/cp-domain/${cp_domain}`,
      method: 'GET',
      params,
    })
  },
  getStatusesDoughnutChart(params={}){
    return API.Axios.error_capture.v1.request({
      url: `error-capture/chart/statuses`,
      method: 'GET',
      params,
    })
  },
  getAccountCodesDoughnutChart(params={}){
    return API.Axios.error_capture.v1.request({
      url: `error-capture/chart/accountcodes`,
      method: 'GET',
      params,
    })
  },
  getEndpointsDoughnutChart(params={}){
    return API.Axios.error_capture.v1.request({
      url: `error-capture/chart/endpoints`,
      method: 'GET',
      params,
    })
  },
  getCPDomainsDoughnutChart(params={}){
    return API.Axios.error_capture.v1.request({
      url: `error-capture/chart/cp-domains`,
      method: 'GET',
      params,
    })
  },
  syncAmiSocket(data={}){
    return API.Axios.error_capture.v1.request({
      url: `error-capture/ami-socket/sync`,
      method: 'POST',
      data,
    })
  },
  getAmisocket(params={},extra){
    return API.Axios.error_capture.v1.request({
      ...extra,
      url: `error-capture/ami-socket`,
      method: 'GET',
      params,
    })
  },
  downloadAmiSocketExcel(params={}){
    return API.Axios.error_capture.v1.request({
      url: `error-capture/ami-socket/excel/download`,
      method: 'GET',
      params,
      responseType: 'blob'
    })
  },
  syncSip(data={}){
    return API.Axios.error_capture.v1.request({
      url: `error-capture/sip/sync`,
      method: 'POST',
      data,
    })
  },
  getSip(params={},extra){
    return API.Axios.error_capture.v1.request({
      ...extra,
      url: `error-capture/sip`,
      method: 'GET',
      params,
    })
  },
  downloadSipExcel(params={}){
    return API.Axios.error_capture.v1.request({
      url: `error-capture/sip/excel/download`,
      method: 'GET',
      params,
      responseType: 'blob'
    })
  },
  syncWebSocket(data={}){
    return API.Axios.error_capture.v1.request({
      url: `error-capture/web-socket/sync`,
      method: 'POST',
      data,
    })
  },
  getWebSocket(params={}){
    return API.Axios.error_capture.v1.request({
      url: `error-capture/web-socket`,
      method: 'GET',
      params,
    })
  },
  downloadWebSocketExcel(params={}){
    return API.Axios.error_capture.v1.request({
      url: `error-capture/web-socket/excel/download`,
      method: 'GET',
      params,
      responseType: 'blob'
    })
  },
  getWebSocketByCpDomainList(cp_domain='',params={}){
    return API.Axios.error_capture.v1.request({
      url: `error-capture/web-socket/cp-domain/${cp_domain}`,
      method: 'GET',
      params,
    })
  },
  getWebSocketTypesDoughnutChart(params={}){
    return API.Axios.error_capture.v1.request({
      url: `error-capture/web-socket/chart/types`,
      method: 'GET',
      params,
    })
  },
  getWebSocketAccountCodesDoughnutChart(params={}){
    return API.Axios.error_capture.v1.request({
      url: `error-capture/web-socket/chart/accountcodes`,
      method: 'GET',
      params,
    })
  },
  getWebSocketCPDomainsDoughnutChart(params={}){
    return API.Axios.error_capture.v1.request({
      url: `error-capture/web-socket/chart/cp-domains`,
      method: 'GET',
      params,
    })
  },
}